export { filter, check, propType } from './utilities';
import { graphql } from './graphql';
export default graphql;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/graphql-anywhere/lib/index.js
// module id = 524
// module chunks = 0